import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export default function SubscriptionsTab() {
  const [subs, setSubs] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/subscriptions").then(({ data }) => setSubs(data.subscriptions)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="border border-slate-200 bg-white rounded-lg overflow-x-auto">
      <table className="w-full text-sm" data-testid="admin-subs-table">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-100">
            <th className="px-4 py-3 font-semibold">Customer</th>
            <th className="px-4 py-3 font-semibold">Plan</th>
            <th className="px-4 py-3 font-semibold">Cycle</th>
            <th className="px-4 py-3 font-semibold">Status</th>
            <th className="px-4 py-3 font-semibold text-right">MRR</th>
            <th className="px-4 py-3 font-semibold">Renews</th>
          </tr>
        </thead>
        <tbody>
          {subs.map((s) => (
            <tr key={s.user_id} className="border-b border-slate-50 last:border-0">
              <td className="px-4 py-3"><div className="font-medium text-[#0A0F1C]">{s.name}</div><div className="text-xs text-slate-400 font-mono">{s.email}</div></td>
              <td className="px-4 py-3 capitalize">{s.plan_id}</td>
              <td className="px-4 py-3 capitalize text-slate-500">{s.billing_cycle}</td>
              <td className="px-4 py-3"><span className={`text-xs font-medium ${s.status === "active" ? "text-green-600" : "text-amber-600"}`}>{s.status}</span></td>
              <td className="px-4 py-3 text-right font-mono">${s.mrr?.toFixed(2)}</td>
              <td className="px-4 py-3 font-mono text-slate-500 text-xs">{s.current_period_end ? s.current_period_end.slice(0, 10) : "—"}</td>
            </tr>
          ))}
          {subs.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-400">No subscriptions</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
